<template>
    <div>
        <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
                <v-btn
                    class="mr-2 mt-1"
                    fab
                    elevation="0"
                    v-bind="props"
                    color="#FFF"
                    @click="checksDialog = true"
                >
                    <v-badge :color="errorsCount > 0 ? 'red' : 'primary'" :content="errorsCount">
                        <v-icon
                            size="x-large"
                            :color="errorsCount > 0 ? 'red' : 'primary'"
                            class="pb-1"
                            >$oss-warning</v-icon
                        >
                    </v-badge>
                </v-btn>
            </template>
            <span>Contrôle de cohérence</span>
        </v-tooltip>
        <oss-dialog
            v-if="checksDialog"
            v-model="checksDialog"
            title="Contrôle de cohérence"
            @close="checksDialog = false"
        >
            <v-row no-gutters style="width: 750px">
                <v-col cols="12">
                    <template v-if="!errorsCount">
                        <b class="d-flex justify-center align-center my-5">
                            <v-icon color="green" class="mr-2">$oss-circle-check</v-icon>
                            Tous les contrôles ont été validés
                        </b>
                    </template>
                    <template v-else>
                        <b
                            v-for="errorMessage in errorMessages"
                            :key="errorMessage"
                            class="d-flex justify-center align-center my-5"
                        >
                            <v-icon class="mr-2" color="red">$oss-warning</v-icon>
                            {{ errorMessage }}
                        </b>
                    </template>
                </v-col>
            </v-row>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Prop, toNative, Vue } from "vue-facing-decorator";

@Component({})
export class DeclarationManagerCheck extends Vue {
    @Prop({ default: 0 }) errorsCount: number;
    @Prop({ default: null }) errorMessages: Array<string>;

    checksDialog: boolean = false;
}

export default toNative(DeclarationManagerCheck);
</script>
